// Feature: Player DevTools panels (Elements, Console, Network, Performance, State,
// Application, Accessibility, Issues) rendered inside the session page as a dock.
// The panels live in @backstory/player (framework-free); this feature hosts them.
import { registerFeature } from "../registry";

export { DevToolsDock, DEFAULT_DOCK_WIDTH, readDockTab } from "./DevToolsDock";
export type { DockTab } from "./DevToolsDock";
export { PanelHost } from "./PanelHost";
export { SessionInformationPanel } from "./SessionInformationPanel";
export { usePanelFetchers, usePanelActions } from "./hooks";

// No standalone routes: the dock is embedded in /sessions/:id.
registerFeature({});
